<template>
  <tr>
    <td>{{ text }}</td>
    <!-- We inject the value to allow for specific html markup -->
    <slot>
      <td
        class="value-column"
        v-html="correctValue(value) + '' + additionalPropertyText"
      ></td>
    </slot>
  </tr>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TableEntry",
  props: {
    text: {
      type: String,
      default: "MissingText",
    },
    value: {
      type: String | Number | Boolean,
      default: "MissingValue",
    },
    additionalPropertyText: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(["locale"]),
  },
  methods: {
    correctValue: function (val) {
      if (typeof val === "boolean") {
        return this.strings[String(val)][this.locale];
      }

      return val;
    },
  },
  data() {
    return {
      strings: {
        true: {
          de: "Ja",
          it: "Si",
          en: "Yes",
          fr: "Oui",
        },
        false: {
          de: "Nein",
          it: "No",
          en: "No",
          fr: "Non",
        },
      },
    };
  },
};
</script>

<style scoped>
.value-column {
  white-space: pre-line;
}
</style>
